import React, { useState, useContext, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { AppContext } from "../../context/AppContext";
import app1 from "../../images/app1.png";
import arrowdown from "../../images/arrowdown.png";
import play1 from "../../images/play1.png";
import { useSelector } from "react-redux";
import Login from "../authentication/Login";
import { useLocation, useNavigate } from "react-router-dom";
import { eventEmitter } from "../EventEmitter";
import HeadLogo from "./HeadLogo";

const HeaderNew = () => {
  const { isAuthenticated, logout } = useContext(AppContext);
  const location = useLocation();
  const pathName = location.pathname;
  const { user } = useContext(AppContext);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const sidebarRef = useRef(null);
  const [isLoginOpen, setLoginOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const navigate = useNavigate();
  const { settingsData, status, error1 } = useSelector(
    (state) => state.settings
  );
  const basePath = pathName.split("/")[1];
  const route = `/${basePath}`;

  const openLogin = () => {
    setLoginOpen(true);
  };
  const closeLogin = () => {
    setLoginOpen(false);
  };

  // Toggle sidebar open/close state
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // Handle navigation based on current path and pass data via search params or event
  const handleNavigation = (value) => {
    const currentPath = location.pathname;
    if (currentPath == "/myProfile") {
      eventEmitter.emit("customEvent", value);
    } else {
      const searchParams = new URLSearchParams(location.search);
      // Update or set the value of "value"
      searchParams.set("value", value);
      // Use navigate to push the updated URL with new search params
      navigate({
        pathname: "/myProfile",
        search: `?${searchParams.toString()}`,
      });
    }
  };

  // Hook: Close sidebar if clicking outside of it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setIsSidebarOpen(false);
      }
    };

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      // Cleanup event listener on unmount
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  //  alert(basePath);
  // Hook: Make header sticky based on scroll and pathname
  useEffect(() => {
    if (
      route != "/" &&
      route != "/buy" &&
      route != "/plot" &&
      route != "/commercial"
    ) {
      setIsSticky(true);
      return;
    } else {
      setIsSticky(false);
    }
    const handleScroll = () => {
      if (window.scrollY > 380) {
        // Adjust scroll position as needed
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [pathName]);

  // Hook: Listen to loginFirst event to trigger login modal
  useEffect(() => {
    const handleEvent = (msg) => {
      setLoginOpen(msg);
    };
    eventEmitter.on("loginFirst", handleEvent);
    return () => {
      eventEmitter.off("loginFirst", handleEvent); // Clean up the event listener
    };
  }, []);

  const [openDropdown, setOpenDropdown] = useState(null);

  const handleDropdownToggle = (menuName) => {
    setOpenDropdown((prev) => (prev === menuName ? null : menuName));
  };

  return (
    <header
      className={`sticky header
      `}
      style={{ width: isSticky ? "100%" : "90%" }}
    >
      <div className="head-logo">
        <p className="tm_logo">TM</p>
        <HeadLogo settingsData={settingsData} />
        <p className="rera_no">RAJ/A/2025/13871</p>
      </div>

      <div className="container">
        <div
          className="headbase"
          style={{ justifyContent: "end", gap: "15px" }}
        >
        {/* <div style={{color:'#2A2A2A', position:'absolute', fontWeight:'bold'}}>Rera No. - RAJ/A/2025/13871</div> */}
          <div className="head-menu mob">
            <button
              className="sidebar-showbtn"
              type="button"
              onClick={toggleSidebar}
            >
              <svg
                width="26"
                height="25"
                viewBox="0 0 31 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.18311 7.50014C5.18311 6.9084 5.66281 6.42871 6.25453 6.42871H26.6117C27.2034 6.42871 27.6831 6.9084 27.6831 7.50014C27.6831 8.09188 27.2034 8.57157 26.6117 8.57157H6.25453C5.66281 8.57157 5.18311 8.09188 5.18311 7.50014Z"
                  fill="white"
                />
                <path
                  d="M5.18311 14.9998C5.18311 14.408 5.66281 13.9282 6.25453 13.9282L18.0402 13.9285C18.632 13.9285 19.1117 14.4082 19.1117 15C19.1117 15.5917 18.632 16.0714 18.0402 16.0714L6.25453 16.0712C5.66281 16.0712 5.18311 15.5914 5.18311 14.9998Z"
                  fill="white"
                />
                <path
                  d="M6.25453 21.4282C5.66281 21.4282 5.18311 21.9079 5.18311 22.4997C5.18311 23.0913 5.66281 23.571 6.25453 23.571H24.4688C25.0606 23.571 25.5403 23.0913 25.5403 22.4997C25.5403 21.9079 25.0606 21.4282 24.4688 21.4282H6.25453Z"
                  fill="white"
                />
              </svg>
            </button>
          </div>
          <div className="head-profile desk">
            <div className="probtn1">
              <Link to="/aboutUs" style={{ textDecoration: "none" }}>
                <p className="header_text mb-0">About Us</p>
              </Link>
            </div>
          </div>
          <div className="head-profile desk">
            <div className="dropdown-start">
              <button
                className="probtn1"
                type="button"
                data-bs-toggle="dropdown"
                // onClick={() => handleDropdownToggle("services")}
                // aria-expanded={openDropdown === "services"}
              >
                <p className="header_text mb-0">Services</p>
                <img
                  src={require("../../images/arrowup-black.png")}
                  alt="arrow up"
                  style={{
                    width: "12px",
                    // transition: "transform 0.3s ease",
                    // transform:
                    //   openDropdown === "services"
                    //     ? "rotate(180deg)"
                    //     : "rotate(0deg)",
                  }}
                />
              </button>
              <ul className={`dropdown-menu`}>
                {/* <Link to="/">
                  <li style={{ borderBottom: "1px solid #2A2A2A26" }}>
                    <span>Buy Property</span>
                  </li>
                </Link> */}
                <Link to="/plot">
                  <li style={{ borderBottom: "1px solid #2A2A2A26" }}>
                    <span>Plots</span>
                  </li>
                </Link>
                {/* <Link to="/commercial">
                  <li style={{ borderBottom: "1px solid #2A2A2A26" }}>
                    <span>Commercial</span>
                  </li>
                </Link> */}
              </ul>
            </div>
          </div>
          <div className="head-profile desk">
            <div className="dropdown-start">
              <button
                className="probtn1"
                type="button"
                data-bs-toggle="dropdown"
                // onClick={() => handleDropdownToggle("premium")}
                // aria-expanded={openDropdown === "premium"}
              >
                <p className="header_text mb-0">Dream Premium</p>
                <img
                  src={require("../../images/arrowup-black.png")}
                  alt="arrow up"
                  style={{
                    width: "12px",
                    // transition: "transform 0.3s ease",
                    // transform:
                    //   openDropdown === "premium"
                    //     ? "rotate(180deg)"
                    //     : "rotate(0deg)",
                  }}
                />
              </button>
              <ul
                className={`dropdown-menu`}
                style={{ backdropFilter: "blur(4px)" }}
              >
                {/* <Link to="/packagePage">
                  <li style={{ borderBottom: "1px solid #2A2A2A26" }}>
                    <span>Subscription Plans</span>
                  </li>
                </Link> */}
                <Link to="/propertyValuation">
                  <li style={{ borderBottom: "1px solid #2A2A2A26" }}>
                    <span>Property Valuation</span>
                  </li>
                </Link>
                {isAuthenticated && user?.data?.role_id === 6 && (
                  <>
                    <Link to="/addProject">
                      <li style={{ borderBottom: "1px solid #2A2A2A26" }}>
                        <span>Add Project</span>
                      </li>
                    </Link>
                  </>
                )}
                <Link to="/legalAdvice">
                  <li style={{ borderBottom: "1px solid #2A2A2A26" }}>
                    <span>Legal Advice</span>
                  </li>
                </Link>
                <Link to="/homeLoan">
                  <li style={{ borderBottom: "1px solid #2A2A2A26" }}>
                    <span>Home Loans</span>
                  </li>
                </Link>
              </ul>
            </div>
          </div>
          <div className="head-profile desk">
            <div className="dropdown-start">
              <button
                className="probtn1"
                type="button"
                data-bs-toggle="dropdown"
                // onClick={() => handleDropdownToggle("search")}
                // aria-expanded={openDropdown === "search"}
              >
                <p className="header_text mb-0">Top Search</p>
                <img
                  src={require("../../images/arrowup-black.png")}
                  alt="arrow up"
                  style={{
                    width: "12px",
                    // transition: "transform 0.3s ease",
                    // transform:
                    //   openDropdown === "search"
                    //     ? "rotate(180deg)"
                    //     : "rotate(0deg)",
                  }}
                />
              </button>
              <ul
                className={`dropdown-menu`}
                style={{ backdropFilter: "blur(4px)" }}
              >
                <Link to="/">
                  <li style={{ borderBottom: "1px solid #2A2A2A26" }}>
                    <span>Search By Location</span>
                  </li>
                </Link>
                <Link to="/">
                  <li style={{ borderBottom: "1px solid #2A2A2A26" }}>
                    <span>Search By Project</span>
                  </li>
                </Link>
                {/* <Link to="/">
                  <li style={{ borderBottom: "1px solid #2A2A2A26" }}>
                    <span>Search By Builder</span>
                  </li>
                </Link> */}
                <Link to="/">
                  <li style={{ borderBottom: "1px solid #2A2A2A26" }}>
                    <span>Price Trends</span>
                  </li>
                </Link>
                <Link to="/postProperty">
                  <li style={{ borderBottom: "1px solid #2A2A2A26" }}>
                    <span>Post Your Property</span>
                  </li>
                </Link>
              </ul>
            </div>
          </div>
          <div className="head-profile desk">
            <div className="dropdown-start">
              <button
                className="probtn1"
                type="button"
                data-bs-toggle="dropdown"
                // onClick={() => handleDropdownToggle("links")}
                // aria-expanded={openDropdown === "links"}
              >
                <p className="header_text mb-0">Quick Links</p>
                <img
                  src={require("../../images/arrowup-black.png")}
                  alt="arrow up"
                  style={{
                    width: "12px",
                    // transition: "transform 0.3s ease",
                    // transform:
                    //   openDropdown === "links"
                    //     ? "rotate(180deg)"
                    //     : "rotate(0deg)",
                  }}
                />
              </button>
              <ul
                className={`dropdown-menu `}
                style={{ backdropFilter: "blur(4px)" }}
              >
                <Link to="/aboutUs">
                  <li style={{ borderBottom: "1px solid #2A2A2A26" }}>
                    <span>About Us</span>
                  </li>
                </Link>
                <Link to="/team">
                  <li style={{ borderBottom: "1px solid #2A2A2A26" }}>
                    <span>Our Team</span>
                  </li>
                </Link>
                <Link to="/contactUs">
                  <li style={{ borderBottom: "1px solid #2A2A2A26" }}>
                    <span>Contact Us</span>
                  </li>
                </Link>
                <Link to="/blogs">
                  <li style={{ borderBottom: "1px solid #2A2A2A26" }}>
                    <span>Blog</span>
                  </li>
                </Link>
                <Link to="/faq">
                  <li style={{ borderBottom: "1px solid #2A2A2A26" }}>
                    <span>FAQ</span>
                  </li>
                </Link>
                <Link to="/privacypolicy">
                  <li style={{ borderBottom: "1px solid #2A2A2A26" }}>
                    <span>Privacy Policy</span>
                  </li>
                </Link>
                <Link to="/term_condition">
                  <li style={{ borderBottom: "1px solid #2A2A2A26" }}>
                    <span>Terms & Conditions</span>
                  </li>
                </Link>
                <Link to="/career_page">
                  <li style={{ borderBottom: "1px solid #2A2A2A26" }}>
                    <span>Career</span>
                  </li>
                </Link>
              </ul>
            </div>
          </div>
          {/* <div className="desk"  style={{color:'#2A2A2A', fontWeight:'bold', marginTop:'11px'}}>Rera No. - <br /> RAJ/A/2025/13871</div> */}
          <div className="head-profile">
            <div className="dropdown-start">
              <button
                className="probtn"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <img
                  src={require("../../images/user-icon.png")}
                  alt="arrow up"
                  style={{
                    width: "24px",
                  }}
                />
              </button>
              <ul className={`dropdown-menu `}>
                <li className="mob">
                  <div className="profile-name-mob">
                    <div className="pnm-icon">
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.99974 6.53268C9.61977 6.53268 10.9331 5.21938 10.9331 3.59935C10.9331 1.97931 9.61977 0.666016 7.99974 0.666016C6.3797 0.666016 5.06641 1.97931 5.06641 3.59935C5.06641 5.21938 6.3797 6.53268 7.99974 6.53268Z"
                          fill="white"
                        />
                        <path
                          d="M13.8661 12.0336C13.8661 13.8561 13.8661 15.3336 7.99948 15.3336C2.13281 15.3336 2.13281 13.8561 2.13281 12.0336C2.13281 10.211 4.75941 8.73359 7.99948 8.73359C11.2396 8.73359 13.8661 10.211 13.8661 12.0336Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <p style={{ textTransform: "capitalize" }}>
                      Hello, {user?.data?.name || "Guest"}
                    </p>
                  </div>
                </li>
                <li className="desk desk-user-name">
                  <div>
                    <p
                      className="mb-0 "
                      style={{
                        textTransform: "capitalize",
                        fontFamily: "Poppins",
                        fontWeight: 500,
                        fontStyle: "italic",
                        color: "#2A2A2A",
                      }}
                    >
                      Hello, {user?.data?.name || "Guest"}
                    </p>
                  </div>
                </li>
                {isAuthenticated && (
                  <>
                    <Link to="/myProfile">
                      <li style={{ borderBottom: "1px solid #2A2A2A26" }}>
                        <span>My Profile</span>
                      </li>
                    </Link>
                    <Link to="/postProperty">
                      <li style={{ borderBottom: "1px solid #2A2A2A26" }}>
                        <span>Post Property</span>
                      </li>
                    </Link>
                    <a onClick={() => handleNavigation("mySubscription")}>
                      <li style={{ borderBottom: "1px solid #2A2A2A26" }}>
                        <span>My Plan</span>
                      </li>
                    </a>
                    <a onClick={() => handleNavigation("myReviews")}>
                      <li style={{ borderBottom: "1px solid #2A2A2A26" }}>
                        <span>My Reviews</span>
                      </li>
                    </a>
                    {user?.data?.role_id == 6 && (
                      <a onClick={() => handleNavigation("myProjects")}>
                        <li style={{ borderBottom: "1px solid #2A2A2A26" }}>
                          <span>My Projects</span>
                        </li>
                      </a>
                    )}
                    <a onClick={() => handleNavigation("myListings")}>
                      <li style={{ borderBottom: "1px solid #2A2A2A26" }}>
                        <span>My Listed Properties</span>
                      </li>
                    </a>
                    {/* <a onClick={() => handleNavigation("myMessages")}>
                      <li>
                        <span>My Messages</span>
                      </li>
                    </a> */}
                    <a onClick={() => handleNavigation("myTransactions")}>
                      <li style={{ borderBottom: "1px solid #2A2A2A26" }}>
                        <span>My Transactions</span>
                      </li>
                    </a>
                  </>
                )}
                <a onClick={() => handleNavigation("shortlistProperty")}>
                  <li style={{ borderBottom: "1px solid #2A2A2A26" }}>
                    <span>Shortlisted Properties</span>
                  </li>
                </a>
                <a onClick={() => handleNavigation("contactedProperty")}>
                  <li style={{ borderBottom: "1px solid #2A2A2A26" }}>
                    <span>Contacted Properties</span>
                  </li>
                </a>
                <a onClick={() => handleNavigation("viewProperty")}>
                  <li style={{ borderBottom: "1px solid #2A2A2A26" }}>
                    <span>Viewed Properties</span>
                  </li>
                </a>

                {isAuthenticated ? (
                  <li className="mt-2">
                    <button
                      className="boton-elegante"
                      type="button"
                      onClick={logout}
                    >
                      Logout
                    </button>
                  </li>
                ) : (
                  <button
                    className="boton-elegante mt-2"
                    type="button"
                    onClick={openLogin}
                  >
                    Join / Login
                  </button>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* sidebar menu */}
      <section
        ref={sidebarRef}
        className={`sidebar-menu ${isSidebarOpen ? "slide-in" : "slide-out"}`}
      >
        <div className="accordion" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button
                className="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                Download App
              </button>
            </h2>
            <div
              id="collapseOne"
              className="accordion-collapse collapse show"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">
                <div className="appdnlod">
                  <Link to="/">
                    <img src={app1} alt="DreamSakha" className="appStore" />
                  </Link>
                  <Link to="/">
                    <img src={play1} alt="DreamSakha" className="googlePlay" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
              >
                Services
              </button>
            </h2>
            <div
              id="collapseTwo"
              className="accordion-collapse collapse"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">
                <ul>
                  {/* <Link to="/" style={{ color: "#ffffff" }}>
                    <li>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_695_1157)">
                          <rect x="7" y="6" width="8" height="7" fill="white" />
                          <path
                            d="M18.7189 5.59762C18.7104 5.74466 18.6925 5.86582 18.6585 5.96939L17.4264 5.86248L18.6585 5.96939L16.4392 12.3665L16.2113 13.0234C16.0031 13.5015 15.6501 14.0657 15.1432 14.0657H6.61156L6.57511 12.3665L6.55824 11.5801H6.55822L6.57509 12.3665L6.61154 14.0657H6.52902C6.29318 14.0657 6.09303 14.0137 5.93558 13.9099C5.77887 13.8059 5.64768 13.6674 5.54301 13.5031C5.42972 13.3388 5.35134 13.1572 5.28152 12.9583C5.22112 12.7594 5.16826 12.5778 5.13338 12.4046L5.12607 12.3665L5.03719 11.9033L4.83704 10.9082L4.58416 9.57616L4.30481 8.09714L3.53761 4.20482H2.21166C2.03802 4.20482 1.8899 4.16173 1.7757 4.07515C1.65478 3.98861 1.55775 3.88504 1.47944 3.76392C1.40961 3.64268 1.34909 3.51303 1.32271 3.3744C1.29716 3.23636 1.2793 3.10623 1.2793 2.99388C1.2793 2.7604 1.35768 2.57027 1.51516 2.42295C1.68032 2.27593 1.8899 2.19824 2.15976 2.19824H3.94717C4.18307 2.19824 4.37464 2.23284 4.5143 2.30209C4.65391 2.37134 4.76719 2.45753 4.85493 2.56148C4.93324 2.66535 4.99372 2.77771 5.0286 2.89003L5.11546 3.18439C5.14272 3.27945 5.15975 3.4091 5.18529 3.57341L5.25522 4.08396L5.36077 4.74118H17.4544C17.7865 4.74118 18.0386 4.78475 18.2225 4.87081C18.4047 4.95735 18.5359 5.0613 18.6142 5.19091C18.6925 5.32057 18.7274 5.4502 18.7189 5.59762ZM10.379 12.2932H11.2755V12.1444V11.408V11.3969H10.379V12.2932ZM8.75413 5.96909H8.75411V11.6319H8.75413V5.96909ZM12.1026 7.07975C12.0563 7.04006 12.0079 7.0034 11.958 6.96917C11.6499 6.75811 11.2736 6.65102 10.8362 6.65102C10.349 6.65102 9.93659 6.79606 9.61043 7.08215C9.28351 7.36898 9.09378 7.76061 9.04649 8.24622L9.04441 8.26767V8.32559L9.85716 8.41341L9.86554 8.36362L9.86967 8.33908C9.983 7.66609 10.3015 7.33894 10.8434 7.33894C10.8504 7.33894 10.8572 7.33926 10.8641 7.33938C11.1183 7.34383 11.3299 7.43034 11.51 7.60394C11.6942 7.7815 11.7838 7.98002 11.7838 8.21084C11.7838 8.31787 11.7574 8.4271 11.7054 8.53543C11.6693 8.61061 11.553 8.76441 11.2039 9.07022C10.9083 9.32907 10.6982 9.57088 10.5792 9.78896C10.456 10.0147 10.4047 10.3431 10.4222 10.793L10.4251 10.8699H11.1984L11.1988 10.8477L11.2 10.7916C11.2069 10.4579 11.2421 10.2253 11.3047 10.1001C11.3681 9.97345 11.5486 9.77794 11.8413 9.51896C12.1537 9.24257 12.3548 9.0097 12.4562 8.80698C12.5572 8.60504 12.6084 8.39482 12.6084 8.18215C12.6084 7.73827 12.4382 7.3674 12.1026 7.07975ZM7.19687 14.6538C8.05692 14.6538 8.75413 15.3508 8.75413 16.2107C8.75413 17.0706 8.05692 17.7677 7.19687 17.7677C6.33681 17.7677 5.6396 17.0706 5.6396 16.2107C5.6396 15.3508 6.33681 14.6538 7.19687 14.6538ZM14.6717 14.6538C15.5318 14.6538 16.229 15.3508 16.229 16.2107C16.229 17.0706 15.5318 17.7677 14.6717 17.7677C13.8116 17.7677 13.1144 17.0706 13.1144 16.2107C13.1144 15.3508 13.8116 14.6538 14.6717 14.6538Z"
                            fill="white"
                          />
                          <path
                            d="M7.29318 10.0004V5.5697H5.7998L11.3998 0.400391L16.9998 5.56955H15.5065V10.0003H12.5198V6.6773H10.2798V10.0003L7.29318 10.0004Z"
                            fill="#2657A0"
                            stroke="white"
                            stroke-miterlimit="5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_695_1157">
                            <rect width="20" height="20" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>

                      <span style={{ color: "#ffffff" }}>Buy Property</span>
                    </li>
                  </Link> */}
                  {/* <Link to="/rent" style={{ color: "#ffffff" }}>
                    <li>
                      <svg
                        width="19"
                        height="18"
                        viewBox="0 0 19 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_695_1171)">
                          <path
                            d="M10.1354 10.3587C10.7507 10.1998 11.2869 9.82201 11.6436 9.29607C12.0002 8.77014 12.1528 8.13219 12.0727 7.5018C11.9927 6.87142 11.6854 6.29187 11.2086 5.8718C10.7318 5.45173 10.1182 5.21997 9.48274 5.21997C8.84729 5.21997 8.23365 5.45173 7.75685 5.8718C7.28005 6.29187 6.97282 6.87142 6.89275 7.5018C6.81268 8.13219 6.96527 8.77014 7.32191 9.29607C7.67855 9.82201 8.21477 10.1998 8.83004 10.3587L8.93087 10.3852V15.3893C8.93087 15.53 8.98678 15.665 9.08629 15.7645C9.18581 15.864 9.32078 15.9199 9.46152 15.9199H11.5258C11.6665 15.9199 11.8015 15.864 11.901 15.7645C12.0005 15.665 12.0564 15.53 12.0564 15.3893C12.0565 15.3173 12.0419 15.246 12.0136 15.1799C11.9853 15.1137 11.9438 15.054 11.8917 15.0043C11.8396 14.9547 11.7779 14.9162 11.7104 14.8911C11.643 14.8661 11.5711 14.855 11.4992 14.8586H10.0346V13.187H11.5417C11.688 13.187 11.8284 13.1289 11.9319 13.0254C12.0354 12.9219 12.0935 12.7815 12.0935 12.6352C12.0935 12.4888 12.0354 12.3484 11.9319 12.2449C11.8284 12.1414 11.688 12.0833 11.5417 12.0833H10.0346V10.3852L10.1354 10.3587ZM9.48274 9.20186C9.16475 9.2022 8.85648 9.09227 8.61046 8.8908C8.36444 8.68932 8.19589 8.40878 8.13354 8.09696C8.07119 7.78514 8.1189 7.46135 8.26852 7.18076C8.41815 6.90017 8.66045 6.68015 8.95412 6.55819C9.24779 6.43623 9.57467 6.41987 9.87905 6.51191C10.1834 6.60395 10.4465 6.79868 10.6234 7.06293C10.8003 7.32718 10.88 7.64459 10.8491 7.96108C10.8182 8.27756 10.6785 8.57354 10.4538 8.79856C10.1957 9.05542 9.84687 9.20031 9.48274 9.20186Z"
                            fill="white"
                          />
                          <path
                            d="M18.7426 7.34983L9.92318 0.164806L9.88073 0.122354C9.77116 0.03902 9.63625 -0.00407546 9.49866 0.000303666H9.4456C9.3065 -0.00318302 9.1702 0.0397603 9.05822 0.122354L9.02107 0.170112L0.196341 7.34983C0.138963 7.39291 0.0916715 7.448 0.0577618 7.51123C0.0238522 7.57447 0.00414033 7.64434 0 7.71598C0.000404362 7.76945 0.0130491 7.82212 0.0369647 7.86996C0.0608804 7.91779 0.0954317 7.95951 0.137969 7.99191C0.249664 8.0795 0.388809 8.12463 0.530651 8.11927C0.70294 8.11966 0.870639 8.06376 1.00824 7.96008L9.49866 1.06161L17.936 7.96008C18.0735 8.06902 18.2435 8.1288 18.4189 8.12988C18.5588 8.13268 18.6954 8.08776 18.8063 8.00253C18.8492 7.9693 18.884 7.92667 18.9079 7.87792C18.9318 7.82917 18.9443 7.77558 18.9443 7.72128C18.9414 7.64804 18.9217 7.57645 18.8868 7.51203C18.8518 7.44762 18.8025 7.39212 18.7426 7.34983ZM16.5988 8.64992C16.452 8.6492 16.3109 8.70641 16.2061 8.80912C16.153 8.85967 16.111 8.92065 16.0827 8.98824C16.0544 9.05582 16.0404 9.12854 16.0416 9.2018V15.039C16.0416 15.7766 16.0416 16.2595 15.755 16.5566C15.5815 16.6894 15.3833 16.7864 15.172 16.842C14.9606 16.8975 14.7403 16.9106 14.5239 16.8803H12.8152C12.6685 16.8796 12.5274 16.9368 12.4226 17.0395C12.3705 17.0905 12.3294 17.1517 12.3021 17.2193C12.2747 17.2868 12.2615 17.3593 12.2634 17.4322C12.2634 17.5019 12.2771 17.5709 12.3037 17.6353C12.3304 17.6997 12.3695 17.7582 12.4188 17.8074C12.4681 17.8567 12.5266 17.8958 12.5909 17.9225C12.6553 17.9491 12.7243 17.9629 12.794 17.9629H14.5133C15.2031 17.9672 15.8668 17.6994 16.3605 17.2176C16.8542 16.7358 17.1381 16.0789 17.1507 15.3892V9.2018C17.1507 9.06106 17.0947 8.92609 16.9952 8.82657C16.8957 8.72706 16.7607 8.67115 16.62 8.67115L16.5988 8.64992ZM6.73397 16.8909H5.18446C4.96924 16.9212 4.75016 16.9086 4.5398 16.854C4.32945 16.7994 4.13195 16.7037 3.95866 16.5725C3.6615 16.2701 3.6668 15.7872 3.67211 15.0549V9.21772C3.67211 9.07698 3.6162 8.94201 3.51668 8.84249C3.41717 8.74298 3.28219 8.68707 3.14146 8.68707C2.99665 8.68829 2.8579 8.74531 2.75408 8.84626C2.70104 8.89681 2.65903 8.9578 2.63072 9.02538C2.60241 9.09297 2.5884 9.16568 2.58958 9.23895V15.3892C2.58958 16.5779 2.92389 18 4.52115 18H6.7605C6.9053 17.9988 7.04406 17.9418 7.14788 17.8408C7.2026 17.7911 7.24632 17.7304 7.27623 17.6628C7.30615 17.5952 7.32161 17.5221 7.32161 17.4481C7.32161 17.3742 7.30615 17.301 7.27623 17.2334C7.24632 17.1658 7.2026 17.1052 7.14788 17.0554C7.09492 16.9997 7.03048 16.9561 6.95902 16.9277C6.88755 16.8993 6.81076 16.8867 6.73397 16.8909Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_695_1171">
                            <rect width="18.9492" height="18" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      <span style={{ color: "#ffffff" }}>Rent Property</span>
                    </li>
                  </Link> */}
                  <Link to="/plot" style={{ color: "#ffffff" }}>
                    <li>
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.50838 14.3258H9.49275C9.52985 14.3255 9.56533 14.3106 9.59146 14.2842C9.61759 14.2579 9.63225 14.2223 9.63225 14.1852V9.29593L15.3337 5.7038C15.4634 5.62234 15.5656 5.50385 15.6272 5.36366C15.6888 5.22346 15.7069 5.06801 15.6791 4.91743C15.6563 4.80065 15.6051 4.69131 15.5299 4.59908C15.4548 4.50685 15.358 4.43458 15.2483 4.38868L9.585 0.94505V0.948425C9.55931 0.926452 9.52656 0.914471 9.49275 0.914675H8.5095C8.4722 0.914675 8.43644 0.929491 8.41006 0.955864C8.38369 0.982236 8.36888 1.018 8.36888 1.0553V14.1852C8.36888 14.2639 8.43075 14.3258 8.5095 14.3258H8.50838ZM9.63337 2.4548L13.9489 5.08055L9.63337 7.79968V2.45593V2.4548ZM15.6803 13.1581C15.4282 12.8993 15.0728 12.663 14.6284 12.4538C13.8443 12.087 12.7856 11.8069 11.5571 11.6438C11.5203 11.639 11.4831 11.649 11.4536 11.6715C11.4241 11.6941 11.4047 11.7274 11.3996 11.7642L11.2759 12.7418C11.2669 12.8183 11.3209 12.8881 11.3974 12.8993C12.4807 13.0455 13.4336 13.293 14.0918 13.6002C14.7589 13.9129 14.9062 14.1807 14.9062 14.2561C14.9062 14.3967 14.544 14.8039 13.4269 15.1707C12.2535 15.5566 10.6819 15.7669 9 15.7669C7.31812 15.7669 5.7465 15.5566 4.57313 15.1707C3.456 14.8039 3.09375 14.3967 3.09375 14.2561C3.09375 14.0367 3.91275 13.2942 6.4035 12.9263C6.44009 12.921 6.47312 12.9015 6.49544 12.872C6.51776 12.8425 6.52757 12.8055 6.52275 12.7688L6.38775 11.7934C6.38527 11.7749 6.37912 11.757 6.36965 11.7409C6.36019 11.7247 6.34759 11.7106 6.33261 11.6994C6.31763 11.6882 6.30056 11.6801 6.2824 11.6756C6.26425 11.6711 6.24537 11.6702 6.22687 11.6731C5.0535 11.8463 4.04437 12.1276 3.30187 12.4876C2.87437 12.6946 2.53687 12.9286 2.29612 13.1828C1.90912 13.5901 1.82812 13.9917 1.82812 14.2549C1.82812 14.8726 2.241 15.3214 2.5875 15.5903C2.97337 15.8896 3.51 16.1528 4.17937 16.3733C5.47537 16.7986 7.18875 17.0337 9 17.0337C10.8112 17.0337 12.5246 16.7986 13.8206 16.3733C15.7635 15.7366 16.1719 14.8714 16.1719 14.2561C16.1719 13.9838 16.0864 13.5732 15.6803 13.1581Z"
                          fill="white"
                        />
                      </svg>
                      <span style={{ color: "#ffffff" }}>Plots</span>
                    </li>
                  </Link>
                  {/* <Link to="/commercial" style={{ color: "#ffffff" }}>
                    <li>
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.11163 20.6557L13.182 20.6318C13.182 20.6318 15.245 20.6168 16.639 20.6065C17.2994 20.5808 17.9161 20.325 17.8874 19.3074V16.4268C17.9016 15.6523 17.3996 15.3374 16.9405 15.1769C15.5966 14.8078 13.2967 14.1759 13.2967 14.1759V6.16002L9.16904 3.65898V1.3446H8.26752V3.58985L4.11695 6.32311V14.1654L4.11163 20.6557ZM8.23226 15.0501L4.57416 17.4869V16.2252L8.23228 13.7891V15.0501L8.23226 15.0501ZM8.23226 12.7565L4.57416 15.1935V13.9318L8.23228 11.4957V12.7565H8.23226ZM8.23226 10.4634L4.57416 12.8997V11.6389L8.23228 9.2021V10.4633H8.23226V10.4634ZM8.23226 8.19826L4.57416 10.6355V9.37404L8.23228 6.93794V8.19826H8.23226ZM8.23226 5.90515L4.57416 8.34147V7.08067L8.23228 4.64364V5.90513H8.23226V5.90515ZM12.3824 19.6723H9.15246L9.14431 5.00202L12.3824 6.90222V19.6723ZM16.9686 19.7667L13.7696 18.7774V17.5156L16.9686 18.5047V19.7667ZM16.9686 17.7023L13.7696 16.7132V15.4519L16.9686 16.441V17.7023Z"
                          fill="white"
                        />
                      </svg>
                      <span style={{ color: "#ffffff" }}>Commercial</span>
                    </li>
                  </Link> */}
                  {/* <Link to="/living" style={{ color: "#ffffff" }}>
                    <li>
                      <svg
                        width="19"
                        height="18"
                        viewBox="0 0 19 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_695_1189)">
                          <path
                            d="M17.35 8.05L13 6.35V3.5H11V5.6L5.85 3.6C5.5 3.45 5.1 3.5 4.85 3.75L0.350002 7.75C-0.0499983 8.1 -0.0999983 8.75 0.250002 9.15C0.450002 9.4 0.700002 9.5 1 9.5H1.5V16.5H4.5V10.5H7.5V16.5H16.5V10H17C17.4 10 17.8 9.75 17.95 9.35C18.15 8.85 17.9 8.25 17.35 8.05ZM14.5 10.5V12H12.5V10.5H14.5ZM9.5 10.5H11.5V12H9.5V10.5ZM9.5 14.5V13H11.5V14.5H9.5ZM14.5 14.5H12.5V13H14.5V14.5Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_695_1189">
                            <rect width="18.0176" height="18" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      <span style={{ color: "#ffffff" }}>PG/Co-Living</span>
                    </li>
                  </Link> */}
                </ul>
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
              >
                Dream Premium
              </button>
            </h2>
            <div
              id="collapseThree"
              className="accordion-collapse collapse"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">
                <ul>
                  {/* <Link to="/packagePage" style={{ color: "#ffffff" }}>
                    <li>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_312_1198)">
                          <path
                            d="M8.89853 1.47801L10.6243 4.97543L14.8942 5.61117C15.6692 5.72676 15.9127 6.27231 15.3432 6.87029L12.2296 9.91904L12.9929 14.3662C13.0955 15.01 12.4734 15.3841 11.9269 15.01L8.02491 12.9745L4.05313 15.0618C3.52128 15.3334 2.9744 15.1587 3.07361 14.414L3.81994 9.91937L0.611156 6.80313C-0.00855222 6.23154 0.313501 5.7097 1.03276 5.61416L5.4265 4.97575C5.4265 4.97575 6.32816 3.14702 7.15032 1.48132C7.74899 0.36286 8.40544 0.379233 8.89853 1.47801Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_312_1198">
                            <rect width="16" height="16" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      <span>Subscription Plans</span>
                    </li>
                  </Link> */}
                  <Link to="/propertyValuation" style={{ color: "#ffffff" }}>
                    <li>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.29342 12V7.56934H4.80005L10.4001 2.40002L16 7.56919H14.5068V11.9999H11.5201V8.67693H9.28009V11.9999L6.29342 12Z"
                          fill="white"
                          stroke="white"
                          stroke-miterlimit="5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M17.293 13.252C17.1484 12.9102 16.8125 12.7031 16.459 12.7031C16.3418 12.7031 16.2246 12.7246 16.1094 12.7734L14.1016 14.0918C14.1152 14.1719 14.1934 14.5742 13.9844 14.9824C13.8047 15.3379 13.4121 15.5273 12.9297 15.5273H11.7402H10.5195C10.3594 15.5273 10.1543 15.5273 10.1543 15.3359C10.1543 15.1445 10.3594 15.1309 10.5195 15.1309H12.9297C13.4258 15.1309 13.7109 14.8184 13.7109 14.3242C13.7109 13.9414 13.4238 13.5469 12.9277 13.5469L5.58398 13.5449C5.46094 13.5449 5.3418 13.5762 5.23438 13.6367L2.89062 14.9609C2.73242 15.0508 2.63281 15.2187 2.63281 15.4023V17.5762C2.63281 17.9707 3.0625 18.2129 3.40039 18.0098L5.4082 16.7969L9.59375 18.6152H9.59766C9.72266 18.6738 9.86133 18.707 10.002 18.707C10.1152 18.707 10.2305 18.6855 10.3438 18.6406L16.8105 14.4219C17.2695 14.2305 17.4863 13.707 17.293 13.252Z"
                          fill="white"
                        />
                      </svg>
                      <span>Property Valuation</span>
                    </li>
                  </Link>
                  {isAuthenticated && user?.data?.role_id === 6 && (
                    <>
                      <Link to="/addProject" style={{ color: "#ffffff" }}>
                        <li>
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.29342 12V7.56934H4.80005L10.4001 2.40002L16 7.56919H14.5068V11.9999H11.5201V8.67693H9.28009V11.9999L6.29342 12Z"
                              fill="white"
                              stroke="white"
                              stroke-miterlimit="5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M17.293 13.252C17.1484 12.9102 16.8125 12.7031 16.459 12.7031C16.3418 12.7031 16.2246 12.7246 16.1094 12.7734L14.1016 14.0918C14.1152 14.1719 14.1934 14.5742 13.9844 14.9824C13.8047 15.3379 13.4121 15.5273 12.9297 15.5273H11.7402H10.5195C10.3594 15.5273 10.1543 15.5273 10.1543 15.3359C10.1543 15.1445 10.3594 15.1309 10.5195 15.1309H12.9297C13.4258 15.1309 13.7109 14.8184 13.7109 14.3242C13.7109 13.9414 13.4238 13.5469 12.9277 13.5469L5.58398 13.5449C5.46094 13.5449 5.3418 13.5762 5.23438 13.6367L2.89062 14.9609C2.73242 15.0508 2.63281 15.2187 2.63281 15.4023V17.5762C2.63281 17.9707 3.0625 18.2129 3.40039 18.0098L5.4082 16.7969L9.59375 18.6152H9.59766C9.72266 18.6738 9.86133 18.707 10.002 18.707C10.1152 18.707 10.2305 18.6855 10.3438 18.6406L16.8105 14.4219C17.2695 14.2305 17.4863 13.707 17.293 13.252Z"
                              fill="white"
                            />
                          </svg>
                          <span>Add Project</span>
                        </li>
                      </Link>
                    </>
                  )}
                  <Link to="/legalAdvice" style={{ color: "#ffffff" }}>
                    <li>
                      <svg
                        width="17"
                        height="17"
                        viewBox="0 0 17 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.09631 11.3327C8.09631 8.46072 8.09631 5.58772 8.09631 2.71685C8.76249 2.71685 9.42868 2.71685 10.0949 2.71685C10.2043 2.55535 10.1299 2.21216 10.2372 2.05066C12.4749 2.28866 14.5701 2.66903 16.8067 2.90703C16.2722 6.84678 15.7314 10.7812 15.1896 14.7114C12.9923 14.5138 10.4466 14.6636 8.09737 14.6158C7.90399 14.1015 8.42037 13.8253 8.76356 13.7594C10.1331 13.5033 12.3761 13.9528 13.8561 13.7594C13.8561 10.3647 13.8561 6.96897 13.8561 3.57322C12.239 3.57322 10.6197 3.57322 9.00156 3.57322C8.88999 5.98616 8.98562 8.6031 8.95374 11.0957C9.55406 11.2253 10.2957 10.5507 11.0957 10.7143C11.6918 10.8354 12.0754 11.8639 11.6663 12.4748C11.3167 12.9997 9.31074 13.1463 8.42993 13.4747C7.94118 13.6574 7.41949 13.8327 6.90631 14.0452C6.44943 14.2354 5.86931 14.6009 5.43156 14.6647C4.68993 14.7709 4.33718 14.3661 3.90793 14.3321C3.18968 14.2758 1.92424 14.9154 1.24106 14.9505C0.841557 13.8933 0.550432 12.7224 0.195557 11.6185C1.31118 10.71 2.59681 10.0863 3.81337 9.33303C4.99912 8.59991 6.13493 7.64685 7.62031 7.28666C7.43968 8.33535 7.86362 9.77928 7.62031 10.7143C7.50981 11.1403 7.04443 11.2753 6.85849 11.5728C7.16981 11.5792 7.69149 11.3879 8.09631 11.3327ZM14.7125 3.52541C14.7444 6.15935 14.6487 8.91972 14.7603 11.474C15.112 8.8751 15.5062 6.31766 15.8079 3.66778C15.4414 3.6221 15.1088 3.54241 14.7125 3.52541Z"
                          fill="white"
                        />
                        <path
                          d="M11.1414 6.42919C12.3782 6.26025 13.2898 7.0295 13.4258 8.09625C13.8019 11.0468 9.27142 11.2115 9.38086 8.33319C9.42123 7.25581 10.0917 6.57263 11.1414 6.42919ZM9.90467 8.23756C9.90467 8.36506 9.90467 8.4915 9.90467 8.61794C9.96629 8.68488 10.1119 8.66681 10.2372 8.66681C10.2266 8.86869 10.3775 8.90907 10.4285 9.04719C11.6461 9.9875 11.6376 7.24306 12.2379 8.47556C12.1848 8.62963 12.0552 8.70613 11.9043 8.76138C11.9043 8.90481 11.9043 9.04719 11.9043 9.18956C12.5014 9.27775 12.3835 8.653 12.903 8.66575C12.903 8.52338 12.903 8.37994 12.903 8.23756C12.8478 8.18338 12.7352 8.18338 12.6183 8.19081C12.4079 7.74138 12.1423 7.56925 11.712 7.667C11.151 7.79556 11.27 8.67 10.9512 8.71463C10.5114 8.77625 10.5358 8.13238 10.9512 8.09625C10.9417 7.94644 10.9831 7.74669 10.9034 7.667C10.3658 7.65213 10.3966 8.20675 9.90467 8.23756Z"
                          fill="white"
                        />
                      </svg>
                      <span>Legal Advice</span>
                    </li>
                  </Link>
                  <Link to="/homeLoan" style={{ color: "#ffffff" }}>
                    <li>
                      <svg
                        width="14"
                        height="16"
                        viewBox="0 0 14 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.6667 12H2.66675V10.4H10.6667V12ZM10.6667 8.8H2.66675V7.2H10.6667V8.8ZM10.6667 5.6H2.66675V4H10.6667V5.6ZM0.666748 16L1.66675 14.8L2.66675 16L3.66675 14.8L4.66675 16L5.66675 14.8L6.66675 16L7.66675 14.8L8.66675 16L9.66675 14.8L10.6667 16L11.6667 14.8L12.6667 16V0L11.6667 1.2L10.6667 0L9.66675 1.2L8.66675 0L7.66675 1.2L6.66675 0L5.66675 1.2L4.66675 0L3.66675 1.2L2.66675 0L1.66675 1.2L0.666748 0V16Z"
                          fill="white"
                        />
                      </svg>
                      <span>Home Loans</span>
                    </li>
                  </Link>
                </ul>
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseFour"
                aria-expanded="false"
                aria-controls="collapseThree"
              >
                Top Search
              </button>
            </h2>
            <div
              id="collapseFour"
              className="accordion-collapse collapse"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">
                <ul>
                  <Link to="/" style={{ color: "#ffffff" }}>
                    <li>
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9 12C5.4 12 2.5 13.1 2.5 14.5C2.5 15.9 5.4 17 9 17C12.6 17 15.5 15.9 15.5 14.5C15.5 13.1 12.6 12 9 12ZM9 15.5C6.5 15.5 4.5 15.05 4.5 14.5C4.5 13.95 6.5 13.5 9 13.5C11.5 13.5 13.5 13.95 13.5 14.5C13.5 15.05 11.5 15.5 9 15.5Z"
                          fill="white"
                        />
                        <path
                          d="M9 1C6.5 1 4.5 3 4.5 5.5C4.5 8 9 15 9 15C9 15 13.5 8 13.5 5.5C13.5 3 11.5 1 9 1ZM9 7.5C7.9 7.5 7 6.6 7 5.5C7 4.4 7.9 3.5 9 3.5C10.1 3.5 11 4.4 11 5.5C11 6.6 10.1 7.5 9 7.5Z"
                          fill="white"
                        />
                      </svg>
                      <span>Search By Location</span>
                    </li>
                  </Link>
                  <Link to="/" style={{ color: "#ffffff" }}>
                    <li>
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.24976 5.24976H6.74994V7.49976H5.24976V5.24976ZM8.25013 5.24976H9.75032V7.49976H8.25013V5.24976ZM5.24976 8.25013H6.74994V10.5001H5.24976V8.25013ZM8.25013 8.25013H9.75032V10.5001H8.25013V8.25013ZM5.24976 11.2499H6.74994V13.4999H5.24976V11.2499ZM8.25013 11.2499H9.75032V13.4999H8.25013V11.2499Z"
                          fill="white"
                        />
                        <path
                          d="M15.7499 15.0002V7.80019L12.7501 6.3V2.25H2.24994V15.0002H0.749756V16.5004H17.2496V15.0002H15.7494H15.7499ZM3.75013 15.0002V3.75019H11.2499V15.0002H3.75013ZM12.7501 7.94981L14.2503 8.69963V14.9996H12.7501V7.94981Z"
                          fill="white"
                        />
                      </svg>
                      <span>Search By Project</span>
                    </li>
                  </Link>
                  {/* <Link to="/" style={{ color: "#ffffff" }}>
                    <li>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.6222 7.13208V6.55692C16.6222 4.48633 14.4366 2.81836 11.7333 2.81836C9.03007 2.81836 6.84445 4.48633 6.84445 6.55692V7.13208H6.26929V8.56999H17.1974V7.13208H16.6222Z"
                          fill="#DADADA"
                        />
                        <path
                          d="M17.485 8.85756H5.98169V6.84449H6.55685V6.55691C6.55685 4.34253 8.88626 2.53076 11.7333 2.53076C14.5804 2.53076 16.9098 4.34253 16.9098 6.55691V6.84449H17.485V8.85756ZM6.55685 8.2824H16.9098V7.41965H16.3346V6.55691C16.3346 4.65887 14.264 3.10593 11.7333 3.10593C9.2026 3.10593 7.13202 4.65887 7.13202 6.55691V7.41965H6.55685V8.2824ZM8.56992 14.3216H9.14509V17.7726H8.56992V14.3216ZM14.3216 14.3216H14.8967V17.7726H14.3216V14.3216Z"
                          fill="white"
                        />
                        <path
                          d="M12.625 16.047H10.842C10.238 16.047 9.66287 15.7594 9.26025 15.2993L7.87986 13.5163C7.59228 13.1712 7.44849 12.7111 7.44849 12.2509V10.5542C7.44849 9.43264 8.33999 8.54114 9.46156 8.54114H14.0629C15.1844 8.54114 16.0759 9.43264 16.0759 10.5542V12.2509C16.0759 12.7111 15.9321 13.1424 15.6446 13.5163L14.2354 15.2705C13.8328 15.7594 13.2576 16.047 12.625 16.047ZM9.4328 9.14506C8.62757 9.14506 7.99489 9.77774 7.99489 10.583V12.2797C7.99489 12.596 8.10992 12.9124 8.31123 13.1712L9.72038 14.9255C10.008 15.2705 10.4106 15.4719 10.842 15.4719H12.625C13.0563 15.4719 13.4877 15.2705 13.7465 14.9255L15.1557 13.1712C15.357 12.9124 15.472 12.596 15.472 12.2797V10.583C15.472 9.77774 14.8393 9.14506 14.0341 9.14506H9.4328Z"
                          fill="white"
                        />
                        <path
                          d="M7.13208 7.99475V8.88625C7.13208 9.66272 9.03012 10.2954 11.7334 10.2954C14.4367 10.2954 16.3347 9.66272 16.3347 8.88625V7.99475H7.13208Z"
                          fill="#DADADA"
                        />
                        <path
                          d="M11.7334 10.583C9.28893 10.583 6.84448 10.0653 6.84448 8.88625V7.99475H7.41965V8.88625C7.41965 9.34638 8.94383 10.0078 11.7334 10.0078C14.5229 10.0078 16.0471 9.34638 16.0471 8.88625V7.99475H16.6223V8.88625C16.6223 10.0366 14.1778 10.583 11.7334 10.583ZM17.1974 18.6353H16.6223V17.4849C16.6223 17.0823 16.4785 16.9385 16.0183 16.6222L14.7242 15.7019L15.0693 15.2418L16.3634 16.1621C16.8236 16.4784 17.1974 16.766 17.1974 17.4849V18.6353Z"
                          fill="white"
                        />
                        <path
                          d="M12.5962 19.7857H12.021V19.0379L15.6158 16.9386L15.9033 17.4275L12.5962 19.3543V19.7857ZM11.4458 19.7857H10.8707V19.3543L7.56348 17.4275L7.85106 16.9386L11.4458 19.0379V19.7857Z"
                          fill="white"
                        />
                        <path
                          d="M6.84445 18.3477H6.26929V17.485C6.26929 16.766 6.6719 16.4784 7.10327 16.1621L8.39739 15.2418L8.74249 15.702L7.44837 16.6222C6.98824 16.9386 6.84445 17.0823 6.84445 17.485V18.3477Z"
                          fill="white"
                        />
                        <path
                          d="M12.8836 2.81833V2.24316H10.5829V2.81833H9.43262V4.8314H10.5829V5.98173H12.8836V4.8314H14.0339V2.81833H12.8836Z"
                          fill="#DADADA"
                        />
                        <path
                          d="M14.3215 4.83142H13.7463V3.10593H12.8836V2.53076H14.3215V4.83142ZM9.72018 4.83142H9.14502V2.53076H10.5829V3.10593H9.72018V4.83142Z"
                          fill="white"
                        />
                        <path
                          d="M13.1713 5.98171H12.5961V2.53073H10.8706V5.98171H10.2955V1.95557H13.1713V5.98171ZM13.2863 9.14511H10.1805C9.43274 9.14511 8.74254 8.91504 8.10986 8.51243L8.4262 8.02354C8.94385 8.36864 9.54777 8.54119 10.1805 8.54119H13.2863C13.919 8.54119 14.5229 8.36864 15.0406 8.02354L15.3569 8.51243C14.7442 8.92294 14.0238 9.14306 13.2863 9.14511Z"
                          fill="white"
                        />
                      </svg>
                      <span>Search By Builder</span>
                    </li>
                  </Link> */}
                  <Link to="/" style={{ color: "#ffffff" }}>
                    <li>
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.5 2.8125V3.9375H6.75C7.70801 3.9375 8.96704 4.52197 9.4043 5.625H4.5V6.75H9.54492C9.37134 8.21777 7.85962 9 6.75 9H4.5V10.3887L10.2656 15.1875H12.0234L5.94141 10.125H6.75C8.56934 10.125 10.5051 8.78027 10.6699 6.75H13.5V5.625H10.582C10.4106 4.95923 10.0459 4.39014 9.5625 3.9375H13.5V2.8125H4.5Z"
                          fill="white"
                        />
                      </svg>
                      <span>Price Trends</span>
                    </li>
                  </Link>
                  <Link to="/postProperty" style={{ color: "#ffffff" }}>
                    <li>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.34713 16.6806V10.5139H2.2915L9.99994 3.31921L17.7083 10.5137H15.6528V16.6805H11.5416V12.0555H8.45827V16.6805L4.34713 16.6806Z"
                          stroke="white"
                          stroke-miterlimit="5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <span>Post Your Property</span>
                    </li>
                  </Link>
                </ul>
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseFive"
                aria-expanded="false"
                aria-controls="collapseThree"
              >
                Quick Links
              </button>
            </h2>
            <div
              id="collapseFive"
              className="accordion-collapse collapse"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">
                <ul>
                  <Link to="/aboutUs" style={{ color: "#ffffff" }}>
                    <li>
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_300_1107)">
                          <path
                            d="M10.0532 10.3993C9.81954 10.6223 9.65548 10.7616 9.546 10.8499C9.59948 10.5607 9.73882 9.98746 10.0744 8.85851C10.4085 7.74015 10.4372 7.54486 10.4372 7.44896C10.4372 7.28143 10.3676 7.13304 10.246 7.03059C9.97293 6.8055 9.49148 6.84992 8.9101 7.17897C8.5861 7.36066 8.24194 7.65741 7.8574 8.07931L7.657 8.30236L8.32219 8.8151L8.49222 8.64704C8.67744 8.4674 8.80307 8.3503 8.88689 8.27207C8.37915 9.94305 8.13189 10.9816 8.13189 11.4464C8.13189 11.6574 8.19296 11.8325 8.31663 11.9652C8.44128 12.1015 8.61638 12.1727 8.81671 12.1727C9.01303 12.1727 9.23759 12.097 9.51064 11.942C9.75691 11.8023 10.1264 11.4969 10.6431 11.0104L10.8531 10.8096L10.2485 10.2206L10.0532 10.3993ZM16.3828 5.87489C15.9795 4.92004 15.3991 4.06111 14.6649 3.32731C13.9295 2.59098 13.0721 2.01213 12.1208 1.60739C10.1435 0.771658 7.85936 0.771658 5.88104 1.60739C4.92924 2.01213 4.07334 2.591 3.33703 3.32731C2.6017 4.06262 2.02131 4.92258 1.61961 5.87489C1.20272 6.86656 0.989746 7.91526 0.989746 8.9993C0.989746 10.0823 1.20173 11.131 1.61813 12.1217C2.02032 13.075 2.60072 13.9329 3.33597 14.6713C4.0703 15.4066 4.9267 15.9864 5.88005 16.3902C6.87023 16.8095 7.91894 17.0195 8.99939 17.0195C10.0809 17.0195 11.1291 16.8095 12.1198 16.3892C13.0731 15.9854 13.9295 15.4066 14.6639 14.6713C15.3991 13.934 15.9785 13.075 16.3812 12.1212C16.7991 11.131 17.0101 10.0823 17.0101 8.99928C17.0111 7.91526 16.8001 6.86656 16.3828 5.87489ZM15.9906 8.99932C15.9906 12.8585 12.8556 15.9976 9.00047 15.9976C5.1463 15.9976 2.01129 12.8585 2.01129 8.99932C2.01129 5.13857 5.1463 2.00005 9.00047 2.00005C12.8556 2.00003 15.9906 5.13858 15.9906 8.99932ZM9.84476 4.85192C9.69334 5.01847 9.61563 5.22031 9.61563 5.45349C9.61563 5.64526 9.67767 5.81229 9.80037 5.942C9.92502 6.07371 10.0865 6.14134 10.2707 6.14134C10.4196 6.14134 10.6412 6.09592 10.844 5.87034C11.0025 5.69978 11.0822 5.49437 11.0822 5.26575C11.0822 5.07851 11.0176 4.9145 10.8944 4.78731C10.625 4.50976 10.1345 4.53953 9.84476 4.85192Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_300_1107">
                            <rect width="18" height="18" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      <span>About Us</span>
                    </li>
                  </Link>
                  <Link to="/team" style={{ color: "#ffffff" }}>
                    <li>
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_300_1107)">
                          <path
                            d="M10.0532 10.3993C9.81954 10.6223 9.65548 10.7616 9.546 10.8499C9.59948 10.5607 9.73882 9.98746 10.0744 8.85851C10.4085 7.74015 10.4372 7.54486 10.4372 7.44896C10.4372 7.28143 10.3676 7.13304 10.246 7.03059C9.97293 6.8055 9.49148 6.84992 8.9101 7.17897C8.5861 7.36066 8.24194 7.65741 7.8574 8.07931L7.657 8.30236L8.32219 8.8151L8.49222 8.64704C8.67744 8.4674 8.80307 8.3503 8.88689 8.27207C8.37915 9.94305 8.13189 10.9816 8.13189 11.4464C8.13189 11.6574 8.19296 11.8325 8.31663 11.9652C8.44128 12.1015 8.61638 12.1727 8.81671 12.1727C9.01303 12.1727 9.23759 12.097 9.51064 11.942C9.75691 11.8023 10.1264 11.4969 10.6431 11.0104L10.8531 10.8096L10.2485 10.2206L10.0532 10.3993ZM16.3828 5.87489C15.9795 4.92004 15.3991 4.06111 14.6649 3.32731C13.9295 2.59098 13.0721 2.01213 12.1208 1.60739C10.1435 0.771658 7.85936 0.771658 5.88104 1.60739C4.92924 2.01213 4.07334 2.591 3.33703 3.32731C2.6017 4.06262 2.02131 4.92258 1.61961 5.87489C1.20272 6.86656 0.989746 7.91526 0.989746 8.9993C0.989746 10.0823 1.20173 11.131 1.61813 12.1217C2.02032 13.075 2.60072 13.9329 3.33597 14.6713C4.0703 15.4066 4.9267 15.9864 5.88005 16.3902C6.87023 16.8095 7.91894 17.0195 8.99939 17.0195C10.0809 17.0195 11.1291 16.8095 12.1198 16.3892C13.0731 15.9854 13.9295 15.4066 14.6639 14.6713C15.3991 13.934 15.9785 13.075 16.3812 12.1212C16.7991 11.131 17.0101 10.0823 17.0101 8.99928C17.0111 7.91526 16.8001 6.86656 16.3828 5.87489ZM15.9906 8.99932C15.9906 12.8585 12.8556 15.9976 9.00047 15.9976C5.1463 15.9976 2.01129 12.8585 2.01129 8.99932C2.01129 5.13857 5.1463 2.00005 9.00047 2.00005C12.8556 2.00003 15.9906 5.13858 15.9906 8.99932ZM9.84476 4.85192C9.69334 5.01847 9.61563 5.22031 9.61563 5.45349C9.61563 5.64526 9.67767 5.81229 9.80037 5.942C9.92502 6.07371 10.0865 6.14134 10.2707 6.14134C10.4196 6.14134 10.6412 6.09592 10.844 5.87034C11.0025 5.69978 11.0822 5.49437 11.0822 5.26575C11.0822 5.07851 11.0176 4.9145 10.8944 4.78731C10.625 4.50976 10.1345 4.53953 9.84476 4.85192Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_300_1107">
                            <rect width="18" height="18" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      <span>Our Team</span>
                    </li>
                  </Link>
                  <Link to="/contactUs" style={{ color: "#ffffff" }}>
                    <li>
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_312_1290)">
                          <path
                            d="M4 6.5H2.5V7.5L1.5 8.5L1 10L1.5 11L2.5 12L3 12.5H4V7V6.5Z"
                            fill="white"
                          />
                          <path
                            d="M4 6.5C3.41421 6.5 2.5 6.5 2.5 6.5M4 6.5V7V12.5H3L2.5 12L1.5 11L1 10L1.5 8.5L2.5 7.5V6.5M4 6.5H2.5"
                            stroke="white"
                            stroke-width="0.2"
                          />
                          <path
                            d="M15 6L14 6.5V12.5H15L15.5 12L16.5 11.5L17 10.5V8.5L15.5 7.5V7L15 6Z"
                            fill="white"
                            stroke="white"
                            stroke-width="0.2"
                          />
                          <circle cx="9.80005" cy="16" r="1.5" fill="white" />
                          <path
                            d="M15.9593 7.2123V6.84141C15.9593 6.48105 15.7729 6.16289 15.4882 5.95547C15.5075 5.90801 15.5181 5.85703 15.5181 5.8043C15.5198 2.44336 12.8462 0.0966797 9.01943 0.0966797C5.29639 0.0966797 2.5876 2.57168 2.52432 5.9959C2.25361 6.2209 2.07783 6.55488 2.07783 6.93281V7.21406C1.14619 7.45312 0.444824 8.49727 0.444824 9.74707C0.444824 11.0355 1.19189 12.1061 2.16924 12.2994C2.35381 12.7477 2.79326 13.057 3.30127 13.057C3.97627 13.057 4.52471 12.5086 4.52471 11.8336V6.93105C4.52471 6.27363 4.00264 5.73926 3.35049 5.71289C3.55439 2.90742 5.87119 0.908789 9.01943 0.908789C11.8249 0.908789 14.6497 2.39766 14.7024 5.71289C14.045 5.73047 13.5142 6.22793 13.5142 6.84141V11.9232C13.5142 12.0727 13.5476 12.215 13.6038 12.3469C13.5511 12.4154 13.5142 12.498 13.5142 12.5912V13.4666C13.5142 14.4721 12.7829 15.307 11.8249 15.4758C11.6228 14.5635 10.8089 13.8779 9.83682 13.8779C8.71182 13.8779 7.79775 14.7937 7.79775 15.917C7.79775 17.0402 8.71182 17.9561 9.83682 17.9561C10.8317 17.9561 11.6597 17.2389 11.8372 16.2967C13.2382 16.1156 14.3263 14.9168 14.3263 13.4666V12.985C14.4546 13.0271 14.5917 13.0553 14.7376 13.0553C15.272 13.0553 15.7272 12.7371 15.8925 12.2941C16.8558 12.0885 17.594 11.025 17.594 9.74531C17.594 8.49727 16.8909 7.45137 15.9593 7.2123ZM3.7126 6.93105V11.8318C3.7126 12.0586 3.52803 12.2432 3.30127 12.2432C3.09209 12.2432 2.91631 12.0867 2.89346 11.8775L2.84775 11.5154H2.48389C1.81768 11.5154 1.25693 10.7033 1.25693 9.74355C1.25693 8.78379 1.81943 7.97168 2.48389 7.97168H2.88994V6.93105C2.88994 6.7043 3.07451 6.51973 3.30127 6.51973C3.52803 6.51973 3.7126 6.7043 3.7126 6.93105ZM9.83682 17.1439C9.16006 17.1439 8.60986 16.5938 8.60986 15.917C8.60986 15.2402 9.16006 14.69 9.83682 14.69C10.5136 14.69 11.0638 15.2402 11.0638 15.917C11.0638 16.5938 10.5136 17.1439 9.83682 17.1439ZM15.5532 11.5172H15.1472V11.9232C15.1472 12.0973 14.9591 12.2432 14.7358 12.2432C14.5126 12.2432 14.3245 12.0973 14.3245 11.9232V6.84141C14.3245 6.66738 14.5126 6.52148 14.7358 6.52148C14.9591 6.52148 15.1472 6.66738 15.1472 6.84141V7.97344H15.5532C16.2194 7.97344 16.7802 8.78555 16.7802 9.74531C16.7802 10.7051 16.2194 11.5172 15.5532 11.5172Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_312_1290">
                            <rect width="18" height="18" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      <span>Contact Us</span>
                    </li>
                  </Link>
                  <Link to="/blogs" style={{ color: "#ffffff" }}>
                    <li>
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_867_24)">
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M8.25737 1.50001C9.13271 1.49767 9.98049 1.80596 10.6499 2.37001L10.7624 2.46001C11.0982 2.34305 11.449 2.27486 11.8041 2.25751C12.8668 2.29982 13.8717 2.7525 14.6075 3.52037C15.3434 4.28824 15.7528 5.31149 15.7499 6.37501C15.7513 7.44634 15.3347 8.47597 14.5887 9.24492C13.8428 10.0139 12.8263 10.4615 11.7554 10.4925C11.0526 10.9909 10.2108 11.2554 9.34931 11.2487C8.4878 11.242 7.65026 10.9643 6.95537 10.455C6.76712 10.485 6.57662 10.5 6.38612 10.5C5.82719 10.4989 5.27425 10.3848 4.76061 10.1644C4.24697 9.94395 3.78325 9.62187 3.39737 9.21751C1.68512 7.41751 1.88462 4.08601 4.06712 2.75701C4.65273 2.40148 5.32454 2.21317 6.00962 2.21251H6.05462C6.69487 1.7477 7.46619 1.49821 8.25737 1.50001ZM5.25737 5.25001H9.75362C9.95253 5.25001 10.1433 5.17099 10.2839 5.03034C10.4246 4.88969 10.5036 4.69892 10.5036 4.50001C10.5036 4.3011 10.4246 4.11033 10.2839 3.96968C10.1433 3.82903 9.95253 3.75001 9.75362 3.75001H5.26037C5.06146 3.75001 4.87069 3.82903 4.73004 3.96968C4.58939 4.11033 4.51037 4.3011 4.51037 4.50001C4.51037 4.69892 4.58939 4.88969 4.73004 5.03034C4.87069 5.17099 5.06146 5.25001 5.26037 5.25001H5.25737ZM5.26037 8.23126H12.7544C12.9533 8.23126 13.144 8.15224 13.2847 8.01159C13.4253 7.87094 13.5044 7.68017 13.5044 7.48126C13.5044 7.28235 13.4253 7.09158 13.2847 6.95093C13.144 6.81028 12.9533 6.73126 12.7544 6.73126H5.26037C5.06146 6.73126 4.87069 6.81028 4.73004 6.95093C4.58939 7.09158 4.51037 7.28235 4.51037 7.48126C4.51037 7.68017 4.58939 7.87094 4.73004 8.01159C4.87069 8.15224 5.06146 8.23126 5.26037 8.23126ZM8.25737 1.23473e-05C7.31665 -0.00203313 6.39286 0.250099 5.58362 0.729762C5.30307 0.806715 5.01526 0.854222 4.72487 0.871512C4.43789 0.944017 4.15763 1.04087 3.88712 1.16101C3.08148 1.52025 2.37893 2.07602 1.84389 2.77734C1.30886 3.47866 0.958476 4.30308 0.824868 5.17501C0.613651 6.38026 0.78252 7.62137 1.30808 8.72637C1.83363 9.83137 2.68986 10.7456 3.75812 11.3423C4.56661 11.7724 5.46807 11.9982 6.38387 12H6.57212C7.42669 12.4919 8.39557 12.7506 9.38162 12.75C10.3919 12.7538 11.3839 12.4812 12.2504 11.9618C13.6286 11.8175 14.9038 11.1656 15.8279 10.1329C16.752 9.10026 17.2589 7.76074 17.2499 6.37501C17.2499 6.27076 17.2499 6.16651 17.2386 6.06976C17.158 4.67582 16.5635 3.36126 15.57 2.3802C14.5764 1.39914 13.2545 0.821257 11.8596 0.758262H11.7396C11.5204 0.768687 11.3022 0.793743 11.0864 0.833262C10.2428 0.289908 9.26077 0.000659259 8.25737 1.23473e-05Z"
                            fill="white"
                          />
                          <path
                            d="M2.98558 15.7492C3.81359 15.7492 4.48483 15.078 4.48483 14.25C4.48483 13.422 3.81359 12.7507 2.98558 12.7507C2.15757 12.7507 1.48633 13.422 1.48633 14.25C1.48633 15.078 2.15757 15.7492 2.98558 15.7492Z"
                            fill="white"
                          />
                          <path
                            d="M1.5 18C1.91421 18 2.25 17.6642 2.25 17.25C2.25 16.8358 1.91421 16.5 1.5 16.5C1.08579 16.5 0.75 16.8358 0.75 17.25C0.75 17.6642 1.08579 18 1.5 18Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_867_24">
                            <rect width="18" height="18" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      <span>Blog</span>
                    </li>
                  </Link>
                  <Link to="/faq" style={{ color: "#ffffff" }}>
                    <li>
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.973 6.3241C9.55431 6.3241 8.31268 7.33068 8.0216 8.71689C7.96696 8.97783 8.1337 9.2336 8.39418 9.28824C8.65466 9.34382 8.91089 9.17613 8.96553 8.91566C9.16383 7.97267 10.0079 7.28874 10.973 7.28874C12.104 7.28874 13.0243 8.20912 13.0243 9.34006C13.0243 10.471 12.104 11.3914 10.973 11.3914C10.7559 11.3914 10.5416 11.3575 10.3367 11.2906C10.3361 11.2904 10.3356 11.2902 10.335 11.2901C10.2885 11.2751 10.2389 11.267 10.1873 11.267C10.0502 11.267 9.92665 11.3242 9.83886 11.4159C9.83866 11.4161 9.83847 11.4163 9.83825 11.4165C9.83361 11.4214 9.82908 11.4264 9.82464 11.4314C9.82325 11.4329 9.82191 11.4345 9.82055 11.4361C9.81723 11.44 9.81398 11.4439 9.81079 11.4479C9.8087 11.4505 9.80663 11.4531 9.80459 11.4558C9.80213 11.459 9.79971 11.4622 9.79733 11.4655C9.79491 11.4688 9.79256 11.4721 9.79023 11.4755C9.78823 11.4784 9.78627 11.4813 9.78434 11.4842C9.78194 11.4879 9.77957 11.4916 9.77724 11.4953C9.77541 11.4983 9.77361 11.5013 9.77185 11.5042C9.76968 11.5079 9.76754 11.5116 9.76548 11.5153C9.76361 11.5187 9.7618 11.5221 9.76 11.5255C9.75822 11.529 9.75644 11.5324 9.75473 11.5358C9.75272 11.5399 9.75081 11.544 9.74892 11.5481C9.74758 11.551 9.74624 11.5539 9.74494 11.5569C9.74283 11.5617 9.74085 11.5666 9.73892 11.5715C9.73795 11.574 9.73696 11.5764 9.73604 11.5788C9.73402 11.5842 9.73212 11.5896 9.7303 11.5951C9.72975 11.5967 9.72909 11.5983 9.72856 11.6C9.72837 11.6006 9.72819 11.6013 9.72799 11.6019C9.72639 11.6069 9.72489 11.612 9.72344 11.6171C9.72258 11.6201 9.7217 11.6231 9.72091 11.6261C9.71997 11.6296 9.71915 11.6333 9.7183 11.6369C9.71715 11.6416 9.71601 11.6464 9.71502 11.6511C9.71476 11.6524 9.71454 11.6537 9.71427 11.655C9.70713 11.6907 9.70412 11.7264 9.70502 11.7616V13.1619C9.70502 13.4285 9.92074 13.6443 10.1873 13.6443C10.454 13.6443 10.6697 13.4285 10.6697 13.1619V12.3403C10.7702 12.3504 10.8713 12.356 10.973 12.356C12.6362 12.356 13.989 11.0032 13.989 9.34006C13.989 7.67688 12.6362 6.3241 10.973 6.3241Z"
                          fill="white"
                        />
                        <path
                          d="M10.1872 14.178C9.92057 14.178 9.70483 14.3937 9.70483 14.6603V14.9613C9.70483 15.2279 9.92055 15.4436 10.1872 15.4436C10.4538 15.4436 10.6695 15.2279 10.6695 14.9613V14.6603C10.6695 14.3937 10.4538 14.178 10.1872 14.178Z"
                          fill="white"
                        />
                        <path
                          d="M11.0003 3.19983C7.01073 3.19983 3.76538 6.44518 3.76538 10.4343C3.76538 12.0876 4.33673 13.6942 5.3777 14.9806V18.3178C5.3777 18.501 5.48132 18.6683 5.64572 18.7497C5.71355 18.7837 5.78702 18.8001 5.86003 18.8001C5.96319 18.8001 6.06588 18.7671 6.1516 18.7022L8.24152 17.1172C9.12328 17.4836 10.0498 17.6692 11.0003 17.6692C14.9894 17.6692 18.2348 14.4239 18.2348 10.4343C18.2347 6.44518 14.9894 3.19983 11.0003 3.19983ZM11.0003 16.7045C10.0879 16.7045 9.20005 16.5067 8.36163 16.1162C8.16616 16.0249 7.94288 16.0795 7.80488 16.2373L6.34234 17.3466V14.9128C6.37062 14.7719 6.33528 14.6203 6.23589 14.5044C5.26463 13.3683 4.73002 11.9232 4.73002 10.4343C4.73002 6.97698 7.54297 4.16449 11.0003 4.16449C14.4576 4.16449 17.2701 6.97698 17.2701 10.4343C17.2701 13.8916 14.4576 16.7045 11.0003 16.7045Z"
                          fill="white"
                        />
                      </svg>
                      <span>FAQ</span>
                    </li>
                  </Link>
                  <Link to="/privacypolicy" style={{ color: "#ffffff" }}>
                    <li>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.9045 16H2.09564C1.5528 16 1.11157 15.5595 1.11157 15.0167V7.63613C1.11157 7.09254 1.5528 6.65206 2.09564 6.65206H4.06375V4.19186C4.06375 2.01828 5.82648 0.256348 8.00006 0.256348C10.1736 0.256348 11.9364 2.01828 11.9364 4.19186V6.65205H13.9045C14.4473 6.65205 14.8885 7.09252 14.8885 7.63611V15.0166C14.8885 15.5595 14.4473 16 13.9045 16ZM10.9523 4.19186C10.9523 2.56185 9.63008 1.23965 8.00006 1.23965C6.36929 1.23965 5.04782 2.56185 5.04782 4.19186V6.65205H10.9523V4.19186ZM13.9045 8.62018C13.9045 8.0766 13.464 7.63613 12.9204 7.63613H3.07972C2.53613 7.63613 2.09565 8.0766 2.09565 8.62019V14.0326C2.09565 14.5754 2.53613 15.0166 3.07972 15.0166H12.9204C13.464 15.0166 13.9045 14.5754 13.9045 14.0326V8.62019V8.62018ZM8.49208 12.4867V14.5246H7.508V12.4867C6.66117 12.2668 6.0319 11.5042 6.0319 10.5883C6.0319 9.50116 6.91286 8.62019 8.00004 8.62019C9.08723 8.62019 9.96818 9.50116 9.96818 10.5883C9.96818 11.5042 9.33893 12.2669 8.49207 12.4867L8.49208 12.4867ZM8.00006 9.60427C7.45647 9.60427 7.016 10.0447 7.016 10.5883C7.016 11.1319 7.45645 11.5724 8.00006 11.5724C8.54365 11.5724 8.98413 11.1319 8.98413 10.5883C8.98413 10.0447 8.54365 9.60427 8.00006 9.60427Z"
                          fill="white"
                        />
                      </svg>
                      <span>Privacy Policy</span>
                    </li>
                  </Link>
                  <Link to="/term_condition" style={{ color: "#ffffff" }}>
                    <li>
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_300_1115)">
                          <path
                            d="M14.0053 7.2694L9.57268 2.857L11.7629 0.676758L16.1956 5.08916L14.0053 7.2694ZM11.085 2.90891L14.0575 5.86782L14.7876 5.14107L11.8151 2.18217L11.085 2.90891ZM9.25979 12.0452L4.82715 7.63278L7.01739 5.45253L11.45 9.86493L9.25979 12.0452ZM6.28731 7.63278L9.25979 10.5917L9.98987 9.86493L7.01739 6.90603L6.28731 7.63278Z"
                            fill="white"
                          />
                          <path
                            d="M9.92168 10.1504L6.72168 7.35038L11.1006 3.5188L14.3006 6.3188L9.92168 10.1504ZM8.34975 7.35038L9.92168 8.72582L12.7287 6.3188L11.1568 4.94336L8.34975 7.35038Z"
                            fill="white"
                          />
                          <path
                            d="M10.5112 7.97141L11.2691 7.30835L18.0902 13.2769L17.3323 13.9399L10.5112 7.97141Z"
                            fill="white"
                          />
                          <path
                            d="M0.740234 16.7273H13.8311V17.5455H0.740234V16.7273Z"
                            fill="white"
                          />
                          <path
                            d="M3.19482 14.2727H11.3766V15.0909H3.19482V14.2727Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_300_1115">
                            <rect width="18" height="18" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      <span>Terms & Conditions</span>
                    </li>
                  </Link>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {isSidebarOpen && <div className="overlay" onClick={toggleSidebar}></div>}

      <Login isOpen={isLoginOpen} onClose={closeLogin} />
    </header>
  );
};

export default HeaderNew;
